// Module
var code = `<!-- Overlap Conflict Resolution Modal -->
<!-- The .modal element acts as the backdrop (same pattern as main calendar modal) -->
<div class="modal fade z-index-modal-nested nested-modal-backdrop" ng-class="{'show': \$ctrl.show}"
  ng-style="{'display': \$ctrl.show ? 'block' : 'none'}" ng-click="\$ctrl.cancel()" tabindex="-1" role="dialog"
  aria-labelledby="overlapConflictModalLabel" ng-attr-aria-hidden="{{!\$ctrl.show}}">
  <div class="modal-dialog modal-lg" role="document" ng-click="\$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="overlapConflictModalLabel">
          <i class="fas fa-exclamation-triangle text-warning"></i> Interval Overlap Conflict
        </h5>
        <button type="button" class="btn-close" ng-click="\$ctrl.cancel()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-warning" role="alert">
          <strong>⚠️ Time Overlap Detected!</strong>
          <span
            ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents && \$ctrl.localConflict.overlappingEvents.length === 1">
            The moved interval conflicts with <strong>1 existing interval</strong>. </span>
          <span
            ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents && \$ctrl.localConflict.overlappingEvents.length > 1">
            The moved interval conflicts with <strong>{{\$ctrl.localConflict.overlappingEvents.length}} existing
              intervals</strong>. </span>
          <br><br>
          <strong>🎯 Choose Resolution:</strong><br> • <strong>NEW WINS:</strong> Moved interval gets highest priority
          (<span
            ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents">{{\$ctrl.getMaxPriority(\$ctrl.localConflict.overlappingEvents)
            + 1}}</span>)<br> • <strong>EXISTING WIN:</strong> Moved interval gets lowest priority (<span
            ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents">{{\$ctrl.getMinPriority(\$ctrl.localConflict.overlappingEvents)
            - 1 > 0 ? \$ctrl.getMinPriority(\$ctrl.localConflict.overlappingEvents) - 1 : 1}}</span>)
        </div>
        <div class="row" ng-show="\$ctrl.localConflict">
          <!-- NEW WINS Option -->
          <div class="col-md-6">
            <div class="card conflict-option-card h-100 cursor-pointer transition-base"
              ng-class="{'selected border-success bg-light': \$ctrl.localConflict.selectedEvent === 'dragged'}"
              ng-click="\$ctrl.selectConflictWinner('dragged')" role="button" tabindex="0"
              ng-keydown="\$event.keyCode === 13 && \$ctrl.selectConflictWinner('dragged')">
              <div class="card-header text-white"
                ng-class="{'bg-success': \$ctrl.localConflict.selectedEvent === 'dragged', 'bg-primary': \$ctrl.localConflict.selectedEvent !== 'dragged'}">
                <h5 class="mb-0">
                  <i class="fas fa-trophy me-2"></i>NEW WINS <i
                    ng-show="\$ctrl.localConflict.selectedEvent === 'dragged'" class="fas fa-check-circle float-end"></i>
                </h5>
              </div>
              <div class="card-body">
                <h6 class="card-title text-primary">{{\$ctrl.localConflict.draggedEvent.title}}</h6>
                <div class="mb-2">
                  <strong>📅 Time:</strong><br>
                  <small class="text-muted">{{\$ctrl.formatDateTime(\$ctrl.localConflict.draggedEvent.start)}} →
                    {{\$ctrl.formatDateTime(\$ctrl.localConflict.draggedEvent.end)}}</small>
                </div>
                <div class="mb-3">
                  <strong>📊 Priority:</strong>
                  <span class="badge bg-secondary me-2">Current:
                    {{\$ctrl.localConflict.draggedEvent.extendedProps.priority}}</span>
                  <br><br>
                  <div ng-show="\$ctrl.localConflict.selectedEvent === 'dragged'" class="alert alert-success p-2">
                    <strong>🎯 New Priority: {{\$ctrl.localConflict.calculatedPriority}}</strong><br>
                    <small>Higher than all {{\$ctrl.localConflict.overlappingEvents.length}} conflicting interval<span
                        ng-if="\$ctrl.localConflict.overlappingEvents.length > 1">s</span></small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- EXISTING WIN Option -->
          <div class="col-md-6">
            <div class="card conflict-option-card h-100 cursor-pointer transition-base"
              ng-class="{'selected border-warning bg-light': \$ctrl.localConflict.selectedEvent === 'existing'}"
              ng-click="\$ctrl.selectConflictWinner('existing')" role="button" tabindex="0"
              ng-keydown="\$event.keyCode === 13 && \$ctrl.selectConflictWinner('existing')">
              <div class="card-header text-white"
                ng-class="{'bg-warning': \$ctrl.localConflict.selectedEvent === 'existing', 'bg-secondary': \$ctrl.localConflict.selectedEvent !== 'existing'}">
                <h5 class="mb-0">
                  <i class="fas fa-shield-alt me-2"></i>EXISTING WIN <i
                    ng-show="\$ctrl.localConflict.selectedEvent === 'existing'"
                    class="fas fa-check-circle float-end"></i>
                </h5>
              </div>
              <div class="card-body">
                <h6 class="card-title text-secondary">Keep Current Schedule</h6>
                <div class="mb-2">
                  <strong>📋 Conflicts with <span
                      ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents">{{\$ctrl.localConflict.overlappingEvents.length}}</span><span
                      ng-if="!\$ctrl.localConflict || !\$ctrl.localConflict.overlappingEvents">0</span> interval<span
                      ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents && \$ctrl.localConflict.overlappingEvents.length > 1">s</span>:</strong>
                </div>
                <div class="conflict-summary mb-3" ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents">
                  <div ng-repeat="event in \$ctrl.localConflict.overlappingEvents | limitTo:3" class="small mb-1">
                    <i class="fas fa-circle text-danger me-1" style="font-size: 6px; vertical-align: middle;"></i>
                    <strong>{{event.title}}</strong> (Priority: {{event.extendedProps.priority}}) <br><small
                      class="text-muted ms-3">{{\$ctrl.formatDateTime(event.start)}} →
                      {{\$ctrl.formatDateTime(event.end)}}</small>
                  </div>
                  <div
                    ng-if="\$ctrl.localConflict && \$ctrl.localConflict.overlappingEvents && \$ctrl.localConflict.overlappingEvents.length > 3"
                    class="small text-muted">
                    <i class="fas fa-ellipsis-h me-1"></i>... and {{\$ctrl.localConflict.overlappingEvents.length - 3}}
                    more interval<span ng-if="\$ctrl.localConflict.overlappingEvents.length - 3 > 1">s</span>
                  </div>
                </div>
                <div ng-show="\$ctrl.localConflict.selectedEvent === 'existing'" class="alert alert-warning p-2">
                  <strong>📉 New Priority: {{\$ctrl.localConflict.calculatedPriority}}</strong><br>
                  <small>Lower than all existing intervals</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" ng-click="\$ctrl.cancel()">
          <i class="fas fa-times"></i> Cancel Move </button>
        <button type="button" class="btn btn-success" ng-click="\$ctrl.resolve()"
          ng-disabled="!\$ctrl.localConflict.selectedEvent">
          <i class="fas fa-check"></i> Apply Priority & Move </button>
      </div>
    </div>
  </div>
</div>`;
// Exports
export default code;